<template>
  <div>
    <h2>{{ title }}</h2>
    <loading :active.sync="isLoading" :is-full-page="true"></loading>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <div v-on:keypress.enter.prevent="getServiceAreaTable(1)">
          <input-search
            :model="search" @update="searchInput"/>
        </div>
        <circle-button
          v-if="permissionServiceArea && permissionServiceArea.permission_id === permission.readWrite"
          @click.native="clearServiceAreaData" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
                <template v-if="header.icon">
                  <a @click="sortDataTable(header.id)">
                    <v-icon class="fas fa-caret-down"
                            v-if="sort == 'desc'"
                            style="font-size: 12px"></v-icon>
                    <v-icon class="fas fa-caret-up"
                            v-if="sort == 'asc'"
                            style="font-size: 12px"></v-icon>
                  </a>
                </template>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>
                {{
                  item.branch ? item.branch.branch_name_th + "-" + item.branch.branch_name_en : ""
                }}
              </td>
              <td>{{ item.floor ? item.floor.floor_name : "" }}</td>
              <td>{{ item.name_th + " (" + item.name_en + ")" }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showServiceArea(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
import {permissionServiceArea, role} from "../../../util/Permission";
import Loading from 'vue-loading-overlay';
import {mapState} from "vuex";
import Swal from 'sweetalert';

export default {
  name: "ServiceAreaTable",
  components: {Paginate, InputSearch, CircleButton, InputTextField, IconPencil, Loading },
  data() {
    return {
      permission : null,
      title: "Service Area",
      isLoading: false,
      headers: [
        { id: 1, text: "No.",icon : null },
        { id: 11, text: "Branch",icon : true },
        { id: 3, text: "Floor",icon : null },
        { id: 4, text: "Service area",icon : null },
        { id: 22, text: "Update date",icon : true },
        { id: 6, text: "edit",icon : null }
      ],
      dataTable: [],
      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      },
      search : '',
      sort_date : 'desc',
      sort_branch : 'desc',
      sort : 'desc',
    };
  },
  computed: {
    permissionServiceArea,
  },
  created() {
    this.permission = role;
    this.getServiceAreaTable(1);
  },
  methods: {
    goToServiceAreaEdit() {
      this.$router.push("/services-area/edit");
    },
    getServiceAreaTable(page) {
      this.isLoading = true;
      this.$store
        .dispatch("ServicesArea/getServiceArea", {
          page,
          search : this.search,
          sort_date : this.sort_date,
          sort_branch : this.sort_branch
        })
        .then(res => {
          if (res.response_code == 200) {
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            }
          } else {
            Swal(res.response_msg);
          }
          this.isLoading = false;
        })
        .catch(() => {
          Swal('','Cannot get data','error');
          this.isLoading = false;
        });
    },
    async changePage(val){
      this.isLoading = true;
      this.dataPaginate.current_page = val;
      await this.getServiceAreaTable(this.dataPaginate.current_page);
      this.isLoading = false;
    },
    showServiceArea(id) {
      this.isLoading = true;
      this.$store.dispatch("ServicesArea/showServiceArea", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("ServicesArea/setFormServiceArea", res.result).then(() => {
            this.goToServiceAreaEdit();
          });
        } else {
          Swal(res.response_msg);
        }
        this.isLoading = false;
      });
    },
    clearServiceAreaData() {
      this.$store.dispatch("ServicesArea/clearFormData").then(() => {
        this.goToServiceAreaEdit();
      });
    },
    searchInput(val){
      this.search = val;
    },
    sortDataTable(header_id){
      this.sort = this.sort == 'desc' ? 'asc' : 'desc';
      if(header_id === 11){ //sort by branch
        this.sort_branch = this.sort_branch == 'desc' ? 'asc' : 'desc';
      }
      if(header_id === 22){ //sort by updated_at
        this.sort_date = this.sort_date == 'desc' ? 'asc' : 'desc';
      }
      this.getServiceAreaTable(1);
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
.branch-data {
  background-color: #e5e5e5;
  margin: 20px;
}
</style>
